import DefaultButton from 'components/button/DefaultButton';
import InputFlexBox from 'components/container/InputFlexBox';
import InputWrappingBox from 'components/container/InputWrappingBox';
import SubmitFlexBox from 'components/container/SubmitFlexBox';
import DefaultLayout from 'components/layout/DefaultLayout';
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { theme } from 'utils/style/theme';
import PromotionLocalizingFrom from './PromotionLocalizingFrom';
import DefaultInput from 'components/input/DefaultInput';
import DefaultSelect from 'components/select/DefaultSelect';
import dayjs from 'dayjs';
import {
  ILocalPromotionProps,
  IPromotionProps,
} from 'utils/types/operationTypes';
import UtcTimer from 'components/etc/UtcTimer';
import RangeDatePicker from 'components/input/RangeDatePicker';
/**
 * * 운영 관리 - 프로모션 등록 & 수정
 * - 등록일 경우, promotionId 값이 -1로 들어온다.
 */

const PromotionInputPage = () => {
  const { promotionId } = useParams();
  const navigate = useNavigate();
  const dateFormat = 'YYYY-MM-DD HH:mm:ss';
  const today: string = dayjs().format(dateFormat);

  const [langList, setLangList] = useState<ILocalPromotionProps[]>([
    {
      key: 0,
      promotion_no: -1,
      lang: 'KO',
      design_id: null,
      image_url: '',
    },
  ]);
  const [detailData, setDetailData] = useState<IPromotionProps>({
    is_public: 0,
    start_date: today,
    end_date: today,
  });

  const handleInputChange = () => {
    ('');
  };
  const handleSelectChange = () => {
    ('');
  };
  const handleDateChange = () => {
    ('');
  };
  /// server 전송
  const handleSubmit = async () => {
    ('');
  };
  const handleGoBack = () => {
    navigate(-1);
  };
  return (
    <DefaultLayout>
      <></>
      <SubmitFlexBox>
        <>
          <DefaultButton
            onClick={handleGoBack}
            backColor={`${theme.colors.sub}`}
          >
            목록보기
          </DefaultButton>
          <DefaultButton onClick={handleSubmit}>저장하기</DefaultButton>
        </>
      </SubmitFlexBox>
      <InputFlexBox style={{ marginTop: '3rem' }}>
        <InputWrappingBox left>
          <PromotionLocalizingFrom
          // langList={langList!}
          // setLangList={setLangList}
          // detailDropList={detailImgDropList!}
          // bannerDropList={bannerImgDropList!}
          />
        </InputWrappingBox>
        <InputWrappingBox>
          <DefaultInput
            title='이미지명'
            name='title'
            // value={detailData?.title}
            onChange={handleInputChange}
            maxLength={60}
            // style={{ marginBottom: theme.margins.bottomInPage }}
          />
          <RangeDatePicker
            title='게시 기간'
            format={dateFormat}
            showTime={true}
            value={[
              dayjs(detailData?.start_date, dateFormat),
              dayjs(detailData?.end_date, dateFormat),
            ]}
            ranges={{
              오늘: [dayjs(), dayjs()],
              이번주: [dayjs().startOf(today as any), dayjs().endOf('week')],
              이번달: [dayjs().startOf(today as any), dayjs().endOf('month')],
            }}
            onChange={handleDateChange}
            style={{ width: '100%' }}
          />
          <UtcTimer
            onGrayBox={true}
            startDate={detailData?.start_date}
            endDate={detailData?.end_date}
            style={{
              marginTop: '0.2rem',
              marginBottom: theme.margins.bottomInModal,
            }}
          />
          <DefaultSelect
            title='프로모션 타입'
            name='promotion_type'
            // value={detailData?.promotion_type}
            // onChange={handleSelectChange}
            // style={{ marginBottom: theme.margins.bottomInPage }}
          />
        </InputWrappingBox>
      </InputFlexBox>
    </DefaultLayout>
  );
};

export default PromotionInputPage;
